/* ---- Section rhythm ---- */
.section {
  padding-block: var(--section-gap);
}

.sectionTight {
  padding-block: clamp(2.5rem, 5vw, 4rem);
}

.sunken {
  background: var(--color-surface-sunken);
}

.invert {
  background: var(--color-surface-invert);
  color: var(--color-text-invert);
}

.atlas {
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(90deg, rgb(6 36 58 / 0.035) 1px, transparent 1px) 0 0 / 44px 44px,
    linear-gradient(0deg, rgb(6 36 58 / 0.035) 1px, transparent 1px) 0 0 / 44px 44px,
    var(--color-bg);
}

.fieldbook {
  background:
    linear-gradient(90deg, rgb(6 36 58 / 0.035) 1px, transparent 1px) 0 0 / 18px 18px,
    var(--color-field-paper);
}

/* ---- Inner-page header (left-aligned, in viewport) ---- */
.pageHeader {
  padding-top: clamp(3.25rem, 6vw, 5rem);
  padding-bottom: clamp(2.5rem, 5vw, 3.75rem);
}

.pageHeaderInner {
  max-width: 50rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.pageTitle {
  font-size: var(--fs-h1);
}

.lede {
  font-size: var(--fs-lead);
  color: var(--color-text-muted);
  line-height: 1.55;
  max-width: 46rem;
}

/* ---- Grids ---- */
.grid2,
.grid3,
.grid4 {
  display: grid;
  gap: 1.25rem;
}

.grid2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid3 {
  grid-template-columns: repeat(3, 1fr);
}

.grid4 {
  grid-template-columns: repeat(4, 1fr);
}

.asymmetric {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(20rem, 0.85fr);
  gap: clamp(1.5rem, 5vw, 4rem);
  align-items: start;
}

.splitReverse {
  display: grid;
  grid-template-columns: minmax(20rem, 0.85fr) minmax(0, 1.15fr);
  gap: clamp(1.5rem, 5vw, 4rem);
  align-items: start;
}

.stackGap {
  margin-top: clamp(2rem, 4vw, 3rem);
}

/* ---- Prose (article / detail bodies) ---- */
.prose {
  max-width: 44rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.prose p {
  font-size: 1.08rem;
  line-height: 1.75;
  color: var(--color-text);
}

/* ---- Disclaimer / note card ---- */
.note {
  border-left: 3px solid var(--color-accent);
  background: var(--color-primary-soft);
  border-radius: var(--radius-sm);
  padding: 1.1rem 1.35rem;
  color: var(--color-primary-strong);
  line-height: 1.55;
}

.sourceGrid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(18rem, 0.48fr);
  gap: clamp(1.25rem, 4vw, 3rem);
  align-items: start;
}

.paperPanel {
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-border);
  background: var(--color-document);
  box-shadow: var(--shadow-md);
}

/* ---- Detail pages (article / update) ---- */
.detailHeader {
  padding-top: clamp(2.5rem, 5vw, 4rem);
  padding-bottom: clamp(1.5rem, 3vw, 2.5rem);
}

.backLink {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-family: var(--font-mono);
  font-size: 0.8rem;
  letter-spacing: 0.04em;
  color: var(--color-text-muted);
  margin-bottom: 1.5rem;
}

.backLink:hover {
  color: var(--color-primary);
}

.detailMeta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.detailCategory {
  font-family: var(--font-mono);
  font-size: 0.76rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--color-accent);
}

.detailDate {
  font-family: var(--font-mono);
  font-size: 0.8rem;
  color: var(--color-text-faint);
}

.detailTitle {
  font-size: var(--fs-h1);
  max-width: 20ch;
  margin-bottom: 0.75rem;
}

/* ---- Simple fallback page (404 etc.) ---- */
.page {
  max-width: var(--layout-max-width);
  margin: 0 auto;
  padding: 4rem 1.25rem 5rem;
}

@media (max-width: 860px) {
  .grid4 {
    grid-template-columns: repeat(2, 1fr);
  }

  .grid3 {
    grid-template-columns: repeat(2, 1fr);
  }

  .asymmetric,
  .splitReverse,
  .sourceGrid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .grid2,
  .grid3,
  .grid4 {
    grid-template-columns: 1fr;
  }
}
